import React, { useState } from 'react';
import { toGpx, messagesToCsv, eventsToCsv, safeFileName } from '../export/formats.js';
import { buildEvidenceZip, saveBlob } from '../export/evidenceZip.js';

const textBlob = (content, type) => new Blob([content], { type });

/**
 * Téléchargements de l'enquête : chaque partie séparément, ou le dossier
 * complet avec manifeste d'empreintes. `onExported` permet à l'application
 * d'inscrire l'empreinte du manifeste côté serveur (traçabilité).
 */
export default function ExportPanel({ bundle, fetchBlob, mediaExporters = [], source = '', onExported, evidence = null, context = {} }) {
    const [busy, setBusy] = useState(null);
    const [error, setError] = useState(null);
    const base = safeFileName(bundle?.title, 'activite');

    const run = async (label, task) => {
        setBusy(label);
        setError(null);
        try {
            await task(message => setBusy(message || label));
        } catch (err) {
            setError(err.message || 'Export impossible');
        } finally {
            setBusy(null);
        }
    };

    return (
        <div className="av-export">
            <button type="button" className="av-button" disabled={!!busy}
                onClick={() => saveBlob(textBlob(toGpx(bundle), 'application/gpx+xml'), `${base}-trajets.gpx`)}>
                Trajets (GPX)
            </button>
            <button type="button" className="av-button" disabled={!!busy}
                onClick={() => saveBlob(textBlob(messagesToCsv(bundle), 'text/csv'), `${base}-messages.csv`)}>
                Messages (CSV)
            </button>
            <button type="button" className="av-button" disabled={!!busy}
                onClick={() => saveBlob(textBlob(eventsToCsv(bundle), 'text/csv'), `${base}-evenements.csv`)}>
                Événements (CSV)
            </button>
            {mediaExporters.map(exporter => (
                <button type="button" key={exporter.id} className="av-button" disabled={!!busy}
                    onClick={() => run(exporter.label, async progress => saveBlob(await exporter.fetch(progress), exporter.fileName))}>
                    {exporter.label}
                </button>
            ))}
            <button type="button" className="av-button av-primary" disabled={!!busy}
                onClick={() => run('Dossier complet', async progress => {
                    const result = await buildEvidenceZip({ bundle, fetchBlob, mediaExporters, source, onProgress: progress, evidence, context: typeof context === 'function' ? await context() : context });
                    if (onExported) await onExported(result);
                    saveBlob(result.blob, result.fileName);
                })}>
                Dossier complet (ZIP)
            </button>
            {busy && <span className="av-export-status">{busy}…</span>}
            {error && <span className="av-error">{error}</span>}
        </div>
    );
}
